import React, { Component, Fragment } from 'react';
import { compose } from 'recompose';
import './Post.css';

import { withAuthorization } from '../../../session/index';
import { createReview, getReviewCheck } from '../../../firebase/api/review';
import { markPostAsRead, markPostAsUnread } from '../../../firebase/api/post';
import { updatePost } from '../../../firebase/api/post';
import { getAuthUser, getUserUid } from '../../../static/localStorage';

import * as ROLES from '../../../constants/roles';

import { Button, Card, CardFooter, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { PostCardHeader } from '../elements/PostCardHeader';
import { PostCardBody } from '../elements/PostCardBody';
import { PostCardFooter } from '../elements/PostCardFooter';
import CreatePostReview from '../reviews/CreatePostReview';
import ReviewsTable from '../reviews/ReviewsTable';
import { ApproveDeclinePost } from '../admin/ApproveDeclinePost';
import { DeletePostButton } from '../elements/DeletePostButton/DeletePostButton';
import DeletePostModal from '../../elements/modal/DeletePostModal';
import { convertDateToFirestoreTimestamp } from '../../../firebase/api/firestoreUtils';
import { EDIT_POST_MINUTES } from '../../../configs';
import UserReview from '../../../components/post/reviews/userReview/UserReview';
import { EditPostButton } from '../elements/EditPostButton/EditPostButton';
import { DeletePostModalIcon } from '../../elements/icons/Icons';
import { sendEmail } from '../../../firebase/api/mail';
import { emailTemplate } from '../../../templates/emailTemplate';
import { getUserByUid } from '../../../firebase/api/users';
import Fog from '../../elements/fog/Fog';
import EmailAllModal from '../../elements/customModals/EmailAllModal';

class Post extends Component {
    //only ADMIN is able to approve/decline a post
    static displayApproveDeclineSection(authUser, isPendingPost) {
        return authUser && authUser.role === ROLES.ADMIN && isPendingPost;
    }

    static displayDeleteSection(isYourPost) {
        return isYourPost;
    }

    static displayEditSection(isYourPost, isApprovedByAdmin) {
        return isYourPost && !isApprovedByAdmin;
    }

    //ADMIN and post owner are able to see reviews
    static displayReviews(authUser, postPublisherUid) {
        return authUser && authUser.uid && authUser.uid === postPublisherUid;
    }

    state = {
        selectedQuestions: [],
        showReviewForm: false,
        isReview: null,
        showDeleteModal: false,
        showImageModal: false,
        isEmailAllModalOpens: false,
    };

    componentDidMount() {
        this.isReviewCheck();
    }

    isReviewCheck = () => {
        const post = this.props.post;
        const userUid = getUserUid();
        const postUid = post ? post.uid : null;
        if (postUid) {
            getReviewCheck(userUid, postUid).then(res => {
                this.setState({ isReview: res && res.docs[0] ? res.docs[0].data() : null });
            });
        }
    };

    onQuestionClick = question => {
        const selectedQuestions = this.state.selectedQuestions;
        selectedQuestions.splice(0, selectedQuestions.length);
        if (question) {
            selectedQuestions.push(question);
            this.setState({ selectedQuestions, showReviewForm: true });
        } else {
            this.setState({ showReviewForm: false });
        }
    };

    onMultipleClick = (event, checkQuestion) => {
        const selectedQuestions = this.state.selectedQuestions;
        if (event.target.checked) {
            selectedQuestions.push(checkQuestion);
        } else {
            selectedQuestions.map((question, index) => {
                if (question.uid === checkQuestion.uid) {
                    selectedQuestions.splice(index, 1);
                }
            });
        }
        this.setState({ selectedQuestions });
    };

    onPublishReview = async (dto, callback) => {
        const { post } = this.props;
        const { questions } = dto;
        createReview(dto).then(id => {
            questions.map(question => {
                post.question.questions[question.order].reviews.push(id);
            });

            updatePost(post).then(res => {
                res && this.setState({ showReviewForm: false });
                callback();
            });

            getUserByUid(post.publisherUid).then(res => {});
        });
        this.isReviewCheck();
        await markPostAsUnread(post.uid);
        this.props.onPostAnswered();
    };

    onAcceptPost = status => {
        const post = {
            ...this.props.post,
            approvedByAdminDate: convertDateToFirestoreTimestamp(new Date()),
        };
        post.isApprovedByAdmin = status;

        updatePost(post).then(() => {
            getUserByUid(post.publisherUid).then(res => {
                const dto = {
                    subject: `Your post is approved!`,
                    sendTo: [res.email],
                    body: emailTemplate(
                        `
                        <h1 class="body-text">Hi ${res.firstName}</h1>
                        <b class="body-text">Congratulations! Your post is out in the big wide world. </b> 
                        <p class="body-text" style="margin-top: 30px; margin-bottom: 30px;">We really hope you get the advice that you need. Since we’re a relatively new platform, we’d like to ask kindly for your patience. If you’ve invited the Validate community to answer your question then it might take a little more time for your post to pick up traction. We’re doing our very best to grow the community, so stick with us!</p>
                        <p class="body-text" style="margin-bottom: 30px;">One small step for you. One giant leap for your ideas!</p>
                        <b class="body-text">Validate team</b>
                        `,
                        'View post',
                        `${window.location.origin}/preview/${this.props.post.uid}`,
                        {
                            headerColor: '#DDE0E6',
                            logoColor: '#1B3256;',
                            bodyBg:
                                'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Fapprove_email_bg.png?alt=media&token=f9d59883-40a7-421e-9d9a-77419076ccea',
                        }
                    ),
                    link: 'links',
                };
                sendEmail(dto);
            });

            this.props.refreshGrid(true);
        });
        this.props.onPostReviewed();
    };

    onDeclinePost = status => {
        const post = { ...this.props.post };
        post.isDeleted = status;
        updatePost(post).then(() => {
            getUserByUid(post.publisherUid).then(res => {
                const dto = {
                    subject: `Uh oh there seems to be a problem.`,
                    sendTo: [res.email],
                    body: emailTemplate(
                        `
                        <h1 class="body-text">Hi ${res.firstName}</h1>
                        <b class="body-text">We’ve just reviewed your recent post and it was rejected. </b> 
                        <p class="body-text" style="margin-top: 30px">Sorry to say this, but it seems like the content you used in your post isn’t appropriate or inline with our rules. It may not be relevant or perhaps it’s showing explicit imagery or wording. 
        We make sure all the content is quality checked to improve the experience for our users. </p>
                        <p class="body-text" style="margin-bottom: 30px;">However, don’t fret, we’ve saved your post so you can swap out the imagery and re-submit by clicking the button below.</p>
                        <p class="body-text" style="margin-bottom: 30px;">If you think this was a mistake then please email us at <a href="mailto:support@validate.biz">support@validate.biz</a></p>
                        <b class="body-text">Validate team</b>
                        `,
                        'Go to post',
                        `${window.location.origin}/preview/${this.props.post.uid}`,
                        {
                            headerColor: '#FEE8EF',
                            logoColor: '#FA6D8E',
                            bodyBg:
                                'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Freject_email_bg.png?alt=media&token=3863b6b6-7fb8-49f2-a65a-9b0379947e57',
                        }
                    ),
                    link: 'links',
                };
                sendEmail(dto);
            });

            return this.props.refreshGrid(true);
        });
        this.props.onPostReviewed();
    };

    showDeleteModalToggle = () => {
        this.setState(prevState => ({
            showDeleteModal: !prevState.showDeleteModal,
        }));
    };

    closePreviewImage = () => {
        this.setState({ showImageModal: false });
    };

    renderFogText() {
        return (
            <>
                <h6 className="font-weight-bold mr-4 card-info fog__text-header">
                    Congratulation on your post!
                </h6>
                <div className="fog__text">
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    It's currently in review, so once approved it will be live.
                </div>
            </>
        );
    }

    handleReviewButtonClick = async () => {
        const { uid: userId } = getAuthUser();
        const { uid: postId } = this.props.post;

        await markPostAsRead(postId);
        this.props.onPostRead(postId);
    };

    handleEmailAllModalToggle = () => {
        this.setState(prevState => ({
            isEmailAllModalOpens: !prevState.isEmailAllModalOpens,
        }));
    };

    handlePostClosed = () => {
        this.props.refreshGrid(true);
    };

    render() {
        const { post, isPendingPost, activeTabMyPosts, activeTabPosts } = this.props;
        const {
            selectedQuestions,
            showReviewForm,
            isReview,
            showDeleteModal,
            showImageModal,
        } = this.state;
        const authUser = getAuthUser();
        const needShowFog = !isPendingPost && !post.isApprovedByAdmin;

        return (
            <Fragment>
                <Card className="PostCard">
                    <PostCardHeader post={post} />
                    <Fog isVisible={needShowFog} text={this.renderFogText}>
                        <PostCardBody
                            post={post}
                            onMultipleClick={this.onMultipleClick}
                            activeTabMyPosts={activeTabMyPosts}
                            activeTabPosts={activeTabPosts}
                            isReview={isReview}
                            showModalImage={url => {
                                this.setState({ showImageModal: url });
                            }}
                        />
                    </Fog>

                    {
                        Post.displayReviews(authUser, post.publisherUid) ? (
                            <ReviewsTable
                                post={post}
                                onReviewButtonClick={this.handleReviewButtonClick}
                                onEmailButtonClick={this.handleEmailAllModalToggle}
                            />
                        ) : (
                            !isReview && (
                                <div>
                                    <PostCardFooter
                                        question={post.question}
                                        showReviewForm={showReviewForm}
                                        onQuestionClick={this.onQuestionClick}
                                        onMultipleQuestionClick={question =>
                                            this.setState({ showReviewForm: question })
                                        }
                                    />
                                    <CreatePostReview
                                        authUser={authUser}
                                        post={post}
                                        showReviewForm={showReviewForm}
                                        question={selectedQuestions}
                                        hideReviewForm={() =>
                                            this.setState({ showReviewForm: false })
                                        }
                                        onPublishReview={this.onPublishReview}
                                    />
                                </div>
                            )
                        )
                        // : <CardFooter>
                        //     <UserReview postType={post.question.type} review={isReview}/>
                        // </CardFooter>
                    }
                    <div className="ApproveDeclinePost">
                        {Post.displayDeleteSection(activeTabMyPosts, post.createdTimestamp) && (
                            <DeletePostButton onDeletePost={this.showDeleteModalToggle} />
                        )}

                        {Post.displayEditSection(activeTabMyPosts, post.isApprovedByAdmin) && (
                            <EditPostButton
                                onEditPost={() =>
                                    this.props.history.push(`/posts/edit/${post.uid}`, post)
                                }
                            />
                        )}
                    </div>

                    {Post.displayApproveDeclineSection(authUser, isPendingPost) && (
                        <ApproveDeclinePost
                            onDeclinePost={this.onDeclinePost}
                            onAcceptPost={this.onAcceptPost}
                        />
                    )}

                    <DeletePostModal
                        modal={showDeleteModal}
                        toggle={this.showDeleteModalToggle}
                        onAccept={this.onDeclinePost}
                        showButton={true}
                    />
                </Card>
                {showImageModal && (
                    <Modal
                        isOpen={showImageModal}
                        toggle={this.closePreviewImage}
                        className="preview-image"
                    >
                        <ModalHeader toggle={this.closePreviewImage} />
                        <ModalBody>
                            <img src={showImageModal} style={{ height: '100%' }} />
                        </ModalBody>
                    </Modal>
                )}
                {this.state.isEmailAllModalOpens && (
                    <EmailAllModal
                        isOpen={this.state.isEmailAllModalOpens}
                        postId={this.props.post.uid}
                        onToggle={this.handleEmailAllModalToggle}
                        onPoseClosed={this.handlePostClosed}
                    />
                )}
            </Fragment>
        );
    }
}

//const condition = authUser => !!authUser && authUser.acceptPolicy === true;
const condition = authUser => !!authUser;

export default compose(withAuthorization(condition))(Post);
